// テナントガード - URL の tenantId が TenantsStore のテナント一覧に含まれるか検証する（認可のみ）
// テナント選択状態の設定は tenantContextResolver が担う
import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  type RouterStateSnapshot,
} from '@angular/router';

import { MeStore } from '../../me/me.store';
import { TenantsStore } from '../tenants.store';

export const tenantGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const meStore = inject(MeStore);
  const tenantsStore = inject(TenantsStore);
  const router = inject(Router);

  // ユーザー情報が未ロードの場合はロードする（TenantsStore に push される）
  if (!meStore.isLoaded()) {
    await meStore.loadMe();
  }

  // loadMe() 失敗時（エラーがある場合）はサインインページへリダイレクト
  if (meStore.error()) {
    return router.createUrlTree(['/signin']);
  }

  const tenantId = route.params['tenantId'] as string | undefined;

  if (!tenantId) {
    return router.createUrlTree(['/tenants']);
  }

  // URL の tenantId がテナント一覧に存在するか確認
  const tenantExists = tenantsStore
    .tenants()
    .some((t) => t.publicId === tenantId);

  if (!tenantExists) {
    return router.createUrlTree(['/tenants']);
  }

  return true;
};
